/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import * as PropTypes from 'prop-types';
import {HighlightCard} from "../../../data/finders.model";
import {connect} from "react-redux";
import {highlightTag} from "../../../actions/finder";
import Block from "../../atoms/layout/Block";
import {push} from 'connected-react-router';

class _PromotionalBanner extends React.Component {

    static propTypes = {
        thematicTitle: PropTypes.string,
        highlight1: PropTypes.shape(HighlightCard),
        highlight2: PropTypes.shape(HighlightCard),
        push: PropTypes.func,
        highlightTag: PropTypes.func,
    };

    static isHighlightEmpty = (highlight) => {
        if (!highlight) {
            return true;
        }

        const {image, title, ctaLink, ctaText, behaviour, tag} = highlight;

        if (behaviour && behaviour.startsWith("PAGELINK_")) {
            return !image && !title && (!ctaLink || !ctaText);
        }

        if (behaviour && behaviour.startsWith("REFINE_FINDER_")) {
            return !image && !title && (!tag || !ctaText);
        }

        return true;
    };

    applyBehaviour = (promotion) => {
        if (promotion.behaviour.startsWith("PAGELINK_") && promotion.ctaLink) {
            return (e) => {
                e.preventDefault();
                window.location = promotion.ctaLink;
            }
        }

        if (promotion.behaviour.startsWith("REFINE_FINDER_") && promotion.tag) {
            return (e) => {
                e.preventDefault();
                this.props.highlightTag(promotion.tag)
            }
        }

        return (e) => e.preventDefault();
    };

    renderPromotionBlock(key, promotion, size) {
        if (!promotion) {
            return null;
        }

        const {image, title, ctaLink, ctaText, behaviour, tag} = promotion;

        return (
            <Block key={"block-" + key} className={"col-sm-" + size + " col-xs-12 promotional-banner"}
                   onClick={this.applyBehaviour(promotion)}>
                <div className="thumbnail thumbnail--large">
                    <div className="thumbnail__image bg-lazyload lazyload" style={{ backgroundImage: image ? "url('" + image + "')" : null }} />
                    { title && <div className="caption">
                        <h5 className="p-margin-bottom-xs">
                            {title}
                        </h5>
                    </div>}
                    { ctaText ? <div className="caption">
                        <React.Fragment>
                            { behaviour.startsWith("PAGELINK_") && ctaLink && <p>
                                <span className="block p-link p-link--negative">
                                    {ctaText}
                                </span>
                            </p>}
                            { behaviour.startsWith("REFINE_FINDER_") && tag && <p>
                                <span className="block p-link p-link--negative">
                                    {ctaText}
                                </span>
                            </p>}
                        </React.Fragment>
                    </div> : null}
                </div>
        </Block>)
    }

    render() {
        const {thematicTitle, highlight1, highlight2} = this.props;

        const hasHighlight1 = !PromotionalBanner.isHighlightEmpty(highlight1);
        const hasHighlight2 = !PromotionalBanner.isHighlightEmpty(highlight2);

        if (!hasHighlight1 && !hasHighlight2) {
            return null;
        }

        const size = hasHighlight1 && hasHighlight2 ? "6" : "12";

        return [
            thematicTitle && <h3 key="title" className="p-section-title p-margin-bottom-none">{thematicTitle}</h3>,
            <Block key="banners" className="row promotional-banners-row">
                { hasHighlight1 && this.renderPromotionBlock(1, highlight1, size) }
                { hasHighlight2 && this.renderPromotionBlock(2, highlight2, size) }
            </Block>
        ];
    }

}


export const PromotionalBanner = connect(undefined, {
    highlightTag,
    push
})(_PromotionalBanner);
